import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Resource } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  activateResource(request: Boundaries["activateResource"]["request"]): void;
}

function useActivateResource(resource: Identifiable<Resource>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isDisableResourceRequestPending(resource),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isDisableResourceRequestSuccess(resource),
    ),
    isRequestFailure: useSelector(() =>
      selector.isDisableResourceRequestFailure(resource),
    ),
    activateResource: core.activateResource,
  };
}

export { useActivateResource };
